module.exports = __webpack_public_path__ + "img/Dead.0444f1fa.svg";